<!-- <div [hidden]="!this.readonly" style="width:100%; display:flex; gap:10px;">
    <div class="label" style="flex:3; min-width:150px;">{{this.addressLabel}}</div>
    <div style="flex:5; min-width:150px;" [innerHtml]="this.formatAddress()"></div>

</div> -->

<div>
  <!-- Hiding this as I don't think having the section title fits with the new design-->
  <!-- <div
    class="cpo-section-title"
    [hidden]="addressLabel == ''"
  >
    {{ this.addressLabel }}
  </div> -->

  <div style="display: flex; gap: 10px">
    <app-textbox
      [label]="'Street 1'"
      [readonly]="readonly"
      [required]="!readonly"
      [showRequired]="this.showRequired"
      [(ngModel)]="data.street1"
      (onChanged)="handleAddressChanged()"
    ></app-textbox>
    <app-textbox
      [label]="'Street 2'"
      [readonly]="readonly"
      [required]="false"
      [showRequired]="this.showRequired"
      [(ngModel)]="data.street2"
      (onChanged)="handleAddressChanged()"
    ></app-textbox>
  </div>
  <div>
    <app-textbox
      [label]="'City'"
      [readonly]="readonly"
      [required]="!readonly"
      [showRequired]="this.showRequired"
      [(ngModel)]="data.city"
      (onChanged)="handleAddressChanged()"
    ></app-textbox>
  </div>
  <div style="display: flex; gap: 10px">
    <app-selectbox
      [label]="'Country'"
      [type]="DDLModes.Countries"
      [options]="countryOptions"
      [readonly]="readonly"
      [required]="!readonly"
      [showRequired]="this.showRequired"
      [(ngModel)]="data.country"
      (onChanged)="onCountryChange($event)"
    ></app-selectbox>
    <app-selectbox
      #ddlState
      [label]="stateLabel"
      [type]="DDLModes.States"
      [options]="stateOptions"
      [readonly]="readonly"
      [required]="!readonly"
      [showRequired]="this.showRequired"
      [(ngModel)]="data.state"
      (onChanged)="handleAddressChanged()"
    ></app-selectbox>
  </div>
  <div>
    <app-textbox
      #txtPostalCode
      [label]="'Postal Code'"
      [type]="inputTextModes.PostalCodeUS"
      [readonly]="readonly"
      [required]="!readonly"
      [showRequired]="this.showRequired"
      [(ngModel)]="data.postalCode"
      (onChanged)="handleAddressChanged()"
    ></app-textbox>
  </div>
</div>
